import React, { useEffect, useState } from "react";

interface LoadingOverlayProps {
  visible: boolean;
}

const LoadingOverlay: React.FC<LoadingOverlayProps> = ({ visible }) => {
  const [shouldRender, setShouldRender] = useState(visible);

  useEffect(() => {
    if (visible) {
      setShouldRender(true);
    } else {
      // Wait for fade-out transition before unmounting
      const timeout = setTimeout(() => setShouldRender(false), 600);
      return () => clearTimeout(timeout);
    }
  }, [visible]);

  if (!shouldRender) return null;

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        background: "linear-gradient(135deg, #f3e8ff 0%, #b3e5fc 100%)",
        zIndex: 9999,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        fontSize: 32,
        color: "#d16ba5",
        fontFamily: "'Fredoka', 'Quicksand', sans-serif",
        letterSpacing: 1.5,
        opacity: visible ? 1 : 0,
        transition: "opacity 0.6s cubic-bezier(.4,2,.6,1)"
      }}
    >
      <div
        style={{
          fontSize: 70,
          marginBottom: 24,
          animation: "spin-heart 2s linear infinite"
        }}
      >
        💖
      </div>
      <div style={{ fontWeight: 700, fontSize: 28, marginBottom: 8 }}>
        Loading your surprise...
      </div>
      <div style={{ fontSize: 18, color: "#7e57c2" }}>Please wait a moment!</div>
      <style>
        {`
          @keyframes spin-heart {
            0% { transform: rotate(0deg);}
            100% { transform: rotate(360deg);}
          }
        `}
      </style>
    </div>
  );
};

export default LoadingOverlay;